@if (pricesFormatted$$()) {
    <div class="formatted-prices">
        <div class="colgap-8" [class.hidden]="emptyExtraPrices$$()" [ngClass]="pricesClasses$$()?.container">
            <!-- Precio terciario -->
            @if (terciaryPricesFormatted$$() && terciaryPricesFormatted$$()?.primaryCurrency) {
                <formatted-price-detail
                    [price$$]="terciaryPricesFormatted$$()"
                    [primaryCurrencyClasses$$]="pricesClasses$$()?.terciaryPrice"
                    [pricesClasses$$]="pricesClasses$$()"
                    [options$$]="options$$()"
                    [pricesFormatted$$]="pricesFormatted$$()"
                    [secondaryPricesFormatted$$]="secondaryPricesFormatted$$()"
                    [secundaryCurrency$$]="true"
                >
                </formatted-price-detail>
            }

            <!-- Precio ultimo precio rebajado -->
            @if (lastReducedPriceFormatted$$() && lastReducedPriceFormatted$$()?.primaryCurrency) {
                <formatted-price-detail
                    [price$$]="lastReducedPriceFormatted$$()"
                    [primaryCurrencyClasses$$]="pricesClasses$$()?.lastReducedPrice"
                    [pricesClasses$$]="pricesClasses$$()"
                    [options$$]="options$$()"
                    [pricesFormatted$$]="pricesFormatted$$()"
                    [secondaryPricesFormatted$$]="secondaryPricesFormatted$$()"
                    [secundaryCurrency$$]="true"
                >
                </formatted-price-detail>
            }

            <!-- Precio secundario -->
            @if (secondaryPricesFormatted$$() && secondaryPricesFormatted$$()?.primaryCurrency) {
                <formatted-price-detail
                    [price$$]="secondaryPricesFormatted$$()"
                    [primaryCurrencyClasses$$]="pricesClasses$$()?.secondaryPrice"
                    [pricesClasses$$]="pricesClasses$$()"
                    [pricesStyles$$]="pricesStyles$$()?.secondaryPrice"
                    [options$$]="options$$()"
                    [pricesFormatted$$]="pricesFormatted$$()"
                    [secondaryPricesFormatted$$]="secondaryPricesFormatted$$()"
                    [secundaryCurrency$$]="true"
                >
                </formatted-price-detail>
            }
        </div>

        <!-- Precio primario -->
        @if (pricesFormatted$$()?.primaryCurrency) {
            <div [class]="primaryPriceContainerClass$$()" [ngStyle]="primaryPriceContainerStyles$$()">
                <div class="text-nowrap title-l">
                    <ng-content select="[primaryText]"></ng-content>

                    <formatted-price-detail
                        [price$$]="pricesFormatted$$()"
                        [options$$]="options$$()"
                        [pricesFormatted$$]="pricesFormatted$$()"
                        [secondaryPricesFormatted$$]="secondaryPricesFormatted$$()"
                        [primaryCurrency$$]="true"
                    >
                    </formatted-price-detail>
                </div>

                <ng-content select="[pricesPromotion]"></ng-content>
            </div>
        }

        <ng-content select="[productPromotionDates]"></ng-content>
    </div>
}

<ng-content select="[productUnitPrice]"></ng-content>
